export default "__VITE_PUBLIC_ASSET__21ec45c2__"